"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeKind = void 0;
var NodeKind;

(function (NodeKind) {
  NodeKind["root"] = "root";
  NodeKind["k8s"] = "k8s";
  NodeKind["cluster"] = "cluster";
  NodeKind["api"] = "api";
  NodeKind["version"] = "version";
  NodeKind["kind"] = "kind";
  NodeKind["resource"] = "resource";
  NodeKind["logic"] = "logic";
  NodeKind["ns"] = "ns";
  NodeKind["app"] = "app";
  NodeKind["cont"] = "cont";
  NodeKind["initcont"] = "initcont"; // sidecont = 'sidecont',

  NodeKind["vols"] = "vols";
  NodeKind["vol"] = "vol";
  NodeKind["mounts"] = "mounts";
  NodeKind["mount"] = "mount";
  NodeKind["configmap"] = "configmap";
  NodeKind["secret"] = "secret";
  NodeKind["replicaset"] = "replicaset";
  NodeKind["hpa"] = "hpa";
  NodeKind["port"] = "port";
  NodeKind["svcaccnt"] = "svcaccnt";
  NodeKind["rlbndg"] = "rlbndg";
  NodeKind["crlbndg"] = "crlbndg";
  NodeKind["rl"] = "rl";
  NodeKind["crl"] = "crl";
  NodeKind["pv"] = "pv";
  NodeKind["pvc"] = "pvc";
  NodeKind["psp"] = "psp";
  NodeKind["netpols"] = "netpols";
  NodeKind["netpol"] = "netpol";
  NodeKind["service"] = "service";
  NodeKind["pod"] = "pod";
  NodeKind["ingress"] = "ingress";
  NodeKind["launcher"] = "launcher";
  NodeKind["job"] = "job";
  NodeKind["cronjob"] = "cronjob";
  NodeKind["image"] = "image";
  NodeKind["infra"] = "infra";
  NodeKind["nodes"] = "nodes";
  NodeKind["pool"] = "pool";
  NodeKind["node"] = "node";
  NodeKind["storage"] = "storage";
  NodeKind["storclass"] = "storclass";
  NodeKind["images"] = "images";
  NodeKind["repo"] = "repo";
  NodeKind["tag"] = "tag";
  NodeKind["gateway"] = "gateway";
  NodeKind["domain"] = "domain";
  NodeKind["url"] = "url";
  NodeKind["pack"] = "pack";
  NodeKind["helm"] = "helm";
  NodeKind["rbac"] = "rbac";
  NodeKind["user"] = "user";
  NodeKind["group"] = "group";
  NodeKind["summary"] = "summary";
  NodeKind["rule_engine"] = "rule_engine";
  NodeKind["rule"] = "rule";
  NodeKind["rule_items"] = "rule_items";
  NodeKind["rule_logs"] = "rule_logs";
  /* Traefik */

  NodeKind["traefik_ingress_route"] = "traefik_ingress_route";
  NodeKind["traefik_service"] = "traefik_service";
  NodeKind["traefik_middleware"] = "traefik_middleware";
  NodeKind["traefik_tls_opts"] = "traefik_tls_opts";
})(NodeKind = exports.NodeKind || (exports.NodeKind = {}));